<template>
  <div class="booking-form__review">
    <div id="quoteGen">
      <div class="header">
        <p>Booking Summary</p>
      </div>
      <div class="shipping-reference mt-3 mb-5">
        <div class="flex justify-between">
          <p>Shipping Reference: {{ shippingInformation.shippingReference }}</p>
          <p>Return Shipping: No</p>
        </div>

        <div class="flex justify-between">
          <p>Service Type: {{ capitalize(shippingMethod) }}</p>
          <p>
            Shipping Option:
            {{ costTypeObject ? costTypeObject.costTye : "Standard Cost" }}
          </p>
        </div>

        <div></div>
      </div>
      <div class="container-fluid">
        <div class="row align-items-center justify-between">
          <div class="col-12 col-md-4 col-lg-4">
            <div class="d-flex my-auto text-light p-2 rounded" style="background: #10233e; min-height: 129px">
              <div>
                <img src="@/assets/images/icons/default-profile-image.svg" alt="user image"
                  class="user-img img-fluid" />
              </div>
              <div class="shipper-details">
                <p>{{ shipper.contactName }}</p>
                <small>{{ shipper.email }}</small> <br />
                <small>{{ shipper.mobile }}</small>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4 col-lg-4">
            <div class="pickup-details p-2 rounded" style="background: #10233e; color: white; min-height: 129px">
              <p class="shipping-detail-title text-light">
                <span><img src="@/assets/images/booking-management/svgs/location.svg" alt="" /></span>ORIGIN
              </p>
              <p class="shipping-detail text-light">
                {{
            `${formatAddress(shipper.address)}

                ${shipper.city == null ? "" : shipper.city}

                ${shipper.country == null ? "" : shipper.country}`
          }}
              </p>
            </div>
          </div>
          <div class="col-12 col-md-4 col-lg-4">
            <div class="p-2 rounded" style="background: #10233e; min-height: 129px">
              <p class="shipping-detail-title text-light">
                <span><img src="@/assets/images/booking-management/svgs/location.svg" alt="" /></span>DESTINATION
              </p>
              <p class="shipping-detail text-light">{{ consignee.contactName }},</p>
              <p class="shipping-detail text-light">
                {{ consignee.address ? consignee.address.name : "N/A" }}
              </p>
              <p class="shipping-detail text-light">
                {{ consignee.email ? consignee.email : "N/A" }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <hr />

      <div class="container-fluid shipping-details">
        <div class="row">
          <div class="col-12">
            <p class="font-semibold">Shipment Details</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 col-lg-3 center">
            <p class="shipping-detail-title">
              <span><img src="@/assets/images/booking-management/svgs/specified-shipment.svg" alt="" /></span>SHIPMENT
              CATEGORY
            </p>
            <p class="shipping-detail">
              {{
            packageInformation.length > 0
              ? packageInformation[0].shipmentType
                ? packageInformation[0].shipmentType
                : "Package"
              : "N/A"
          }}
            </p>
          </div>
          <div class="col-12 col-md-6 col-lg-3">
            <p class="shipping-detail-title">
              <span><img src="@/assets/images/booking-management/svgs/channel-waybill.svg" alt="" /></span>PACKAGE
              DESCRIPTION
            </p>
            <p class="shipping-detail">
              {{
              packageInformation.length > 0 ? packageInformation[0].description : "N/A"
            }}
            </p>
          </div>

          <div class="col-12 col-md-6 col-lg-3 center">
            <p class="shipping-detail-title">
              <span><img src="@/assets/images/booking-management/svgs/booking-channel.svg" alt="" /></span>BOOKING
              CHANNEL
            </p>
            <p class="shipping-detail">MULEEX</p>
          </div>

          <div class="col-12 col-md-6 col-lg-3 right">
            <p class="shipping-detail-title">
              <span><img src="@/assets/images/booking-management/svgs/channel-waybill.svg" alt="" /></span>WAYBILL NO
            </p>
            <p class="shipping-detail">SC02099X</p>
          </div>
        </div>

        <div hidden class="row">
          <div class="col-12 col-md-6 col-lg-3 right cursor-pointer" @click="openRouteInfo">
            <p class="shipping-detail-title"><u>View detailed route info</u></p>
          </div>
        </div>
      </div>

      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <p class="font-semibold">Package Details</p>
          </div>
        </div>
        <div class="row" v-for="(packages, index) in packageInformation" :key="index">
          <div class="col-12 mb-3 mt-2">
            <p class="font-semibold">Package {{ index + 1 }}</p>
          </div>
          <div class="col-12 col-md-6 col-lg-3">
            <p class="shipping-detail-title">
              <span><img src="@/assets/images/booking-management/svgs/number-of-packages.svg" alt="" /></span>NUMBER OF
              PACKAGES
            </p>
            <p class="shipping-detail">{{ packages.quantity }}</p>
          </div>
          <div class="col-12 col-md-6 col-lg-3 center">
            <p class="shipping-detail-title">
              <span><img src="@/assets/images/booking-management/svgs/channel-waybill.svg" alt="" /></span>WEIGHT
            </p>
            <p class="shipping-detail">
              {{ packages.estimatedWeight }}{{ packages.unitOfWeight }}
            </p>
          </div>
          <div class="col-12 col-md-6 col-lg-3 center">
            <p class="shipping-detail-title">
              <span><img src="@/assets/images/booking-management/svgs/dimension.svg" alt="" /></span>DIMENSION (LxWxH)
            </p>
            <p class="shipping-detail">
              <span>
                {{ packages.length ? packages.length + "x" : "" }}
                {{ packages.width ? packages.width + "x" : "" }}
                {{ packages.height ? packages.height : "cm" }}
                ({{ packages.unitOfDimension }})
              </span>
            </p>
          </div>
          <div class="col-12 col-md-6 col-lg-3 right">
            <p class="shipping-detail-title">
              <span><img src="@/assets/images/booking-management/svgs/special-handling.svg" alt="" /></span>SPECIAL
              HANDLING
            </p>
            <p class="shipping-detail">
              {{
            packages.specialHandling.length >= 1
              ? packages.specialHandling.join()
              : "N/A"
          }}
            </p>
          </div>
          <div class="col-12 mt-4 col-md-6 col-lg-3">
            <p class="shipping-detail-title">
              <span><img src="@/assets/images/booking-management/svgs/declared-value.svg" alt="" /></span>DECLARED VALUE
            </p>
            <p class="shipping-detail">₦{{ packages.itemValue }}.00</p>
          </div>
          <div class="col-12 mt-4 col-md-6 col-lg-3">
            <p class="shipping-detail-title">
              <span><img src="@/assets/images/booking-management/svgs/channel-waybill.svg" alt="" /></span>PACKAGE
              DESCRIPTION
            </p>
            <p class="shipping-detail">{{ packages.description }}</p>
          </div>
        </div>
      </div>

      <hr />

      <div class="container-fluid payment-summary">
        <div class="row">
          <div class="col-12">
            <p class="font-semibold">Payment Summary</p>
          </div>
        </div>

        <div>
          <div class="row">
            <div class="col-12 col-md-6 col-lg-3">
              <p class="shipping-detail-title">
                <span><img src="@/assets/images/booking-management/svgs/service.svg" alt="" /></span>
                SERVICE
              </p>
              <p class="shipping-detail">
                {{ shippingService ? shippingService.orgName : $store.state.bookingModule.newBooking.vehicleType ?
            $store.state.bookingModule.newBooking.vehicleType : "MULEEX" }}
              </p>
            </div>
            <div class="col-12 col-md-6 col-lg-3 center">
              <p class="shipping-detail-title">
                <span><img src="@/assets/images/booking-management/svgs/net-shipping-cost.svg" alt="" /></span>NET
                SHIPPING COST
              </p>
              <p class="shipping-detail">
                ₦{{ costTypeObject ? costTypeObject.netPrice : "N/A" }}
              </p>
            </div>
            <div class="col-12 col-md-6 col-lg-3 center">
              <p class="shipping-detail-title">
                <span><img src="@/assets/images/booking-management/svgs/booking-channel.svg" alt="" /></span>HANDLING
                CHARGES
              </p>
              <p class="shipping-detail">
                ₦{{ costTypeObject ? costTypeObject.handlingCharges : "N/A" }}
              </p>
            </div>
            <div class="col-12 col-md-6 col-lg-3 right">
              <p class="shipping-detail-title">
                <span><img src="@/assets/images/booking-management/svgs/insurance.svg" alt="" /></span>INSURANCE
              </p>
              <p class="shipping-detail">
                ₦{{ costTypeObject ? costTypeObject.insuranceFee : "N/A" }}
              </p>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-md-6 col-lg-3 center">
              <p class="shipping-detail-title">
                <span><img src="@/assets/images/booking-management/svgs/total.svg" alt="" /></span>TOTAL
              </p>
              <p class="shipping-detail">
                ₦{{ costTypeObject ? costTypeObject.cost || costTypeObject.totalCost : "N/A" }}
              </p>
            </div>

            <div class="col-12 col-md-6 col-lg-3">
              <p class="shipping-detail-title">
                <span><img src="@/assets/images/booking-management/svgs/total.svg" alt="" /></span>DISCOUNT TOTAL
              </p>
              <p class="shipping-detail">₦0.00</p>
            </div>
            <div class="col-12 col-md-6 col-lg-3 center">
              <p class="shipping-detail-title">
                <span><img src="@/assets/images/booking-management/svgs/tax-vat-charges.svg" alt="" /></span>Tax/VAT
              </p>
              <p class="shipping-detail">
                ₦{{ costTypeObject ? costTypeObject.vat : "N/A" }}
              </p>
            </div>
            <div class="col-12 col-md-6 col-lg-3 center">
              <p class="shipping-detail-title">
                <span><img src="@/assets/images/booking-management/svgs/payment-due.svg" alt="" /></span>PAYMENT DUE
              </p>
              <p class="shipping-detail">
                ₦{{ costTypeObject ? costTypeObject.cost || costTypeObject.totalCost : "N/A" }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="my-4 flex flex-wrap">
        <p class="font-normal text-sm w-full my-2 md:w-6/12">
          This bill excludes duties and other government charges.
        </p>
        <div class="w-full my-2 md:w-6/12">
          <p class="text-right font-bold w-full pb-2">Select Payment Method</p>
          <div class="w-auto flex mt-1 gap-4 justify-end">
            <label for="dropAtTerminal" class="radio-label">
              <input class=" bg-primary-yellow text-secondary-yellow" name="senderShippingMethod" type="radio"
                id="dropAtTerminal" value="onDelivery" v-model="paymentMethod" />
              Pay on Delivery
              <span></span>
            </label>

            <label for="PickAtAddress" class="radio-label">
              <input type="radio" v-model="paymentMethod" value="PayNow" id="PickAtAddress"
                name="senderShippingMethod" />
              Pay Now
              <span></span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="button-wrapper">
      <p class="mt-4 cursor-pointer underline" @click="$emit('back-one-form')">Back</p>
      <div>
        <div class="flex flex-end gap-4 items-center">
          <div class="flex gap-2 items-center">
            <button class="payment-assign h-full font-semibold w-32 rounded flex justify-between items-center p-2 px-3">
              <span class="mr-3 pr-2">Select</span>

              <el-dropdown class="h-full">
                <ArrowDownBlackIcon :style="{ width: '17px', heigth: '10px' }" />

                <!-- <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="userPaymentSettings ? userPaymentSettings.card == true : true">
                    <button @click="showPaymentModal">Charge Card</button>
                  </el-dropdown-item>

                  <el-dropdown-item v-if="userPaymentSettings ? userPaymentSettings.wallet == true : true">
                    <button>Charge Wallet</button>
                  </el-dropdown-item>

                  <el-dropdown-item v-if="userPaymentSettings ? userPaymentSettings.payOnDemand == true : true">
                    <button>Cash Payment</button>
                  </el-dropdown-item>

                  <el-dropdown-item v-if="userPaymentSettings ? userPaymentSettings.cashOnPickup == true : true">
                    <button>Pay on Delivery</button>
                  </el-dropdown-item>
                </el-dropdown-menu> -->
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="isPayNow">
                    <button @click="showPaymentModal">Charge Card</button>
                  </el-dropdown-item>

                  <el-dropdown-item v-if="$store.state.authentication.env == 'development' && isPayNow">
                    <button>Charge Wallet</button>
                  </el-dropdown-item>

                  <el-dropdown-item v-if="isPayDelivery">
                    <button @click="closeCashModal = true">Cash Payment</button>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="isPayDelivery">
                    <button>POS</button>
                  </el-dropdown-item>
                  <!-- <el-dropdown-item v-if="$store.state.authentication.env == 'development' && isPayNow">
                    <button>Save Quote</button>
                  </el-dropdown-item> -->
                </el-dropdown-menu>
              </el-dropdown>
            </button>
          </div>
        </div>
      </div>
    </div>

    <multiple-consignee-modal :show-modal="isMultipleConsigneeModal" @close-modal="isMultipleConsigneeModal = false"
      @change-form="$emit('change-form')" @add-new-consignee="$emit('add-new-consignee')" />
    <view-detailed-route-modal :showModal="viewDetailedRouteModal" :booking="bookingComputed"
      @close-modal="viewDetailedRouteModal = false" />
    <payment-modal :show-modal="isPaymentModal" :email="shipper.email" :paystackkey="paystackkey"
      :total="Number(costTypeObject.cost || costTypeObject.totalCost)" @process-paystack="createTransaction"
      @close-modal="isPaymentModal = false" />

    <CashPaymentModal :total="Number(costTypeObject.cost || costTypeObject.totalCost)" @processCash="createTransaction"
      @close-modal="closeCashModal = false" :showModal="closeCashModal" />
  </div>
</template>

<script>
import MultipleConsigneeModal from "./Modals/MultipleConsigneesModal";
import html2pdf from "html2pdf.js";
import ViewDetailedRouteModal from "./Modals/ViewDetailedRouteModal";
import PaymentModal from "./Modals/NewBookingPaymentModal";
import CashPaymentModal from "./Modals/CashPaymentModal.vue";
import ArrowDownBlackIcon from "../../../../UI/svgs/ArrowDownBlackIcon.vue";

export default {
  name: "booking-review",
  components: {
    ViewDetailedRouteModal,
    MultipleConsigneeModal,
    PaymentModal,
    ArrowDownBlackIcon,
    CashPaymentModal
  },
  data() {
    return {
      reviewDetails: {},
      isMultipleConsigneeModal: false,
      viewDetailedRouteModal: false,
      generatingQuote: false,
      packages: [{}],
      closeCashModal: false,
      paymentMethod: '',
      // costTypeObject: {
      //   totalCost : 9000
      // },
      isPaymentModal: false,
      transactionId: "",
    };
  },
  computed: {
    isPayNow() {
      return this.paymentMethod === 'PayNow'
    },
    isPayDelivery() {
      return this.paymentMethod === 'onDelivery'
    },
    paystackkey() {
      return this.$store.getters.getPaystackKey
    },
    shipper() {
      return this.$store.getters.shipperInformation;
    },
    consignee() {
      return this.$store.getters.consigneeInformation;
    },
    packageInformation() {
      return this.$store.getters.packageInformation;
    },
    shipInformation() {
      return this.$store.getters.shippingInformation;
    },
    shippingInformation() {
      return this.$store.getters.shippingInformation;
    },
    shippingService() {
      return this.$store.getters.shippingService.shippingService;
    },
    costTypeObject() {
      return this.$store.state?.bookingModule?.tripService?.totalCost ? this.$store.state.bookingModule.tripService : this.$store.state.bookingModule.costTypes;
    },
    userPaymentSettings() {
      return this.$store.getters.userPaymentSettings;
    },

    paymentInformation() {
      let totalPaymentInformation = this.$store.getters.paymentInformation;
      return totalPaymentInformation;
    },
    packageType() {
      return this.reviewDetails.packagees;
    },
    takeOffObject() {
      return this.$store.getters.takeOffTerminals.find(
        (x) => x.id == this.shippingInformation.dropOff
      );
    },
    pickUpObject() {
      return this.$store.getters.pickUpTerminals.find(
        (x) => x.id == this.shippingInformation.pickUp
      );
    },
    packagingTypes() {
      let packagingTypes = [];
      this.reviewDetails?.packagees?.forEach((selectedPackage) => {
        packagingTypes.push(selectedPackage.packageType);
      });
      return packagingTypes.join();
    },
    bookingComputed() {
      return {
        consigneelocation: this.consignee,
        shipperlocation: this.$store.getters.shipperInformation,
        shippingservice: this.shippingInformation,
        paymentInformation: this.paymentInformation,
        packagees: this.$store.getters.packages,
      };
    },
    shippingMethod() {
      return this.$store.state.bookingModule.newBooking.shippingMethod;
    },
  },
  async mounted() {
    await this.getReviewDetails();
    await this.setpaymentype()
    this.$nextTick(() => {
      this.$forceUpdate();
    });
    this.$forceUpdate();
    this.transactionId = this.shippingInformation.transactionId;
  },
  methods: {
    async setpaymentype() {
       this.paymentMethod = "PayNow"
    },
    openRouteInfo() {
      this.viewDetailedRouteModal = true;
    },
    showPaymentModal() {
      this.isPaymentModal = true;
    },
    async createTransaction(reference, paymentType) {
      this.isPaymentModal = false;

      try {
        this.changeStatus(reference, paymentType);
      } catch (error) {
        this.handleError(error);
      }
    },
    async changeStatus(reference, paymentType) {
      let payload = {
        breakDown: this.costTypeObject,
        transactionReference: reference || null,
        payment_type: paymentType,
      };
      try {
        const response = await this.$_updatePaymentStatus(payload, this.transactionId);

        console.log(JSON.stringify(response, null, 2));

        if (response.data.success == true) {
          this.$store.dispatch("removeOldConsigneeData");
          this.$router.push({
            name: "Booking3plDirection",
          });
        }
      } catch (error) {
        this.handleError(error);
      }
    },
    generateQuote() {
      try {
        this.generatingQuote = true;
        var element = document.getElementById("quoteGen");
        html2pdf(element);
        this.generatingQuote = false;
      } catch (e) {
        this.generatingQuote = false;
      }
    },
    async getReviewDetails() {
      try {
        const response = await this.$_getPaymentDetails(this.$store.getters.shippingId);
        this.reviewDetails = response.data.data.shipping;
      } catch (error) {
        this.handleError(error);
      }
    },
    splitSpecialHandlings(specialHandling) {
      let specialHandlingList = specialHandling.join();
      return specialHandlingList;
    },
  },
  watch: {
    paymentMethod(val) {
      let type = val == "onDelivery" ? 'Cash' : 'Card';
      this.$store.dispatch(
        "setBookingPaymenttype3pl",
        type
      );
    },
    shipInformation: {
      handler(val) {
        if (this.shippingInformation.shippingMethod == null) {
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        }
        console.log(val);
        this.shippingInformation = { ...val };
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.booking-form__review {
  background: #ffffff;
  border-radius: 2px;
  padding: 2rem 4rem;
}

.payment-assign {
  background: #fcc210;
  color: #10233e;
}

.booking-summary__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 1.5rem 0 4rem 0;
}

p {
  text-transform: capitalize;
}

.booking-form__review {
  padding: 2rem 4rem;
}

.header p {
  color: #383f51;
  font-weight: 600;
}

.row {
  padding-bottom: 1.5rem;
}

.center {
  // padding-left: 4rem;
  // padding-right: 0;
}

.right {
  // padding-left: 5rem;
}

.shipping-detail-title {
  color: #979797;
  font-size: 0.8rem;
  display: flex;
  align-items: center;

  span {
    padding-right: 0.5rem;
  }
}

.shipping-detail {
  color: #10233e;
  font-size: 0.9rem;
  font-weight: 500;
  padding-left: 1.5rem;
}

.user-img {
  width: 4rem;
  margin-right: 1rem;
}

.button {
  background-color: #fcc210;
  color: var(--primaryblue);
  border: 1px solid #fcc008;
  box-sizing: border-box;
  box-shadow: 0px 6px 10px rgba(221, 144, 9, 0.25);
  border-radius: 2px;
  margin-right: 1.5rem;
}

hr {
  margin: 1rem 0;
}

.radio-label span::after {
  background: #bec4d5;
}

.loader,
.loader:after {
  border-radius: 50%;
  width: 25px;
  height: 25px;
  overflow: hidden;
}

.loader {
  overflow: hidden;
  margin: auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 3px solid rgba(255, 255, 255, 0.2);
  border-right: 3px solid rgba(255, 255, 255, 0.2);
  border-bottom: 3px solid rgba(255, 255, 255, 0.2);
  border-left: 3px solid #ffffff;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}

@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
